import React, { useState, useEffect } from 'react';

const API = `${process.env.REACT_APP_API_URL}`;

export default function MobileProviderMyUploads({ user, onBack }) {
  const [uploads, setUploads] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(`${API}/api/Provider/my-uploads/${user.id}`)
      .then(r => r.json()).then(setUploads).catch(() => {})
      .finally(() => setLoading(false));
  }, []); // eslint-disable-line

  return (
    <div className="pb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
      <div className="flex items-center gap-3 px-4 py-4 bg-white border-b border-gray-100 shadow-sm">
        <button onClick={onBack} className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-gray-100">
          <span className="material-symbols-outlined text-gray-500">arrow_back</span>
        </button>
        <p className="font-black text-lg text-[#141a3d]">My Uploads</p>
      </div>

      <div className="px-4 mt-4 space-y-3">
        {loading && <p className="text-center text-gray-400 text-sm py-8">Loading...</p>}
        {!loading && uploads.length === 0 && (
          <div className="bg-white rounded-2xl p-8 text-center shadow-sm">
            <span className="material-symbols-outlined text-gray-200 block mb-2" style={{ fontSize: '48px', fontVariationSettings: '"FILL" 1' }}>upload_file</span>
            <p className="font-bold text-gray-400">No uploads yet</p>
          </div>
        )}
        {uploads.map(u => (
          <div key={u.id} className="bg-white rounded-2xl p-4 flex items-center gap-3 shadow-sm">
            <div className="w-11 h-11 rounded-xl flex items-center justify-center shrink-0" style={{ background: '#ece7fb' }}>
              <span className="material-symbols-outlined" style={{ fontSize: '20px', color: '#5a3fd6', fontVariationSettings: '"FILL" 1' }}>description</span>
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-bold text-sm text-[#141a3d] truncate">{u.fileName}</p>
              <p className="text-xs text-gray-400">{u.reportType} • {u.patientUid}</p>
              <p className="text-xs text-gray-400">{new Date(u.uploadedAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}</p>
            </div>
            <span className={`text-[10px] font-bold px-2 py-1 rounded-full shrink-0 ${
              u.status === 'accepted' ? 'bg-green-100 text-green-700' :
              u.status === 'rejected' ? 'bg-red-100 text-red-700' :
              'bg-amber-100 text-amber-700'
            }`}>{u.status}</span>
          </div>
        ))}
      </div>
    </div>
  );
}